import { useDispatch, useSelector } from 'react-redux';

import getAccounts, { addAccount } from '../services/Accounts/AccountsActions';
import { setAccountsFetch } from '../services/Accounts/AccountsSlice';

const useAccounts = () => {
  const dispatch = useDispatch();
  const { accounts, isAccountsFetching } = useSelector(
    (state) => state.accountsReducer,
  );

  const getDispatchAccounts = (parameters = {}) =>
    dispatch(getAccounts(parameters));
  const setFetchingAccounts = (state) => dispatch(setAccountsFetch(state));
  const addDispatchAccount = (payload) => dispatch(addAccount(payload));

  return {
    accounts,
    isAccountsFetching,
    getDispatchAccounts,
    addDispatchAccount,
    setFetchingAccounts,
  };
};

export default useAccounts;
